<mat-dialog-content>
  <div style="display: flex;">
    <div style="width: 100%">
      <h1 style="font-size: 1.5rem">Allocate Assessments</h1>
    </div>

    <lib-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </lib-icon-button>
  </div>

  <div>
    <lib-content-loader *ngIf="loading" />

    <form [formGroup]="form">
      
      <div>
        <mat-form-field class="full-width" actions appearance="outline" multiple>
          <mat-label>Assessment</mat-label>
          <mat-select formControlName="assessment_id">
            <mat-option *ngFor="let assessment of assessments" [value]="assessment.assessment_id">{{ assessment.name }}</mat-option>  
          </mat-select>
        </mat-form-field>
      </div>

      @if (profile && profile.role_id !== 2) {
        <div>
          <mat-form-field class="full-width" actions appearance="outline" multiple>
            <mat-label>Organization</mat-label>
            <mat-select formControlName="selected_org_id">
              <mat-option *ngFor="let org of orgs" [value]="org.id">{{ org.name }}</mat-option>  
            </mat-select>
          </mat-form-field>
        </div>
      } @else {
        <div>
          <mat-form-field class="full-width" actions appearance="outline">
            <mat-label>Organization</mat-label>
            <input class="org_input" matInput formControlName="org_name" readonly>
          </mat-form-field>
        </div>
      }

      <div>
        <mat-form-field class="full-width" actions appearance="outline">
          <mat-label>Amount</mat-label>
          <input matInput type="number" formControlName="amount">
        </mat-form-field>
      </div>
      

    </form>
  </div>

</mat-dialog-content>

<mat-dialog-actions style="gap: 0.8rem" align="end">
  <lib-button mat-dialog-close>Cancel</lib-button>
  <lib-button type="primary" (click)="allocate()">Allocate</lib-button>
</mat-dialog-actions>